var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankCard2Front(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 240.95 155.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{clip-path:url(#clippath-20);}.cls-2{stroke:#42b654;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20{fill:none;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19{stroke-miterlimit:10;}.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-8,.cls-9,.cls-10,.cls-11,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18{stroke-width:.5px;}.cls-21{clip-path:url(#clippath-11);}.cls-22{clip-path:url(#clippath-16);}.cls-23{letter-spacing:.01em;}.cls-24{fill:#e53338;}.cls-25{letter-spacing:0em;}.cls-26{opacity:.5;}.cls-3{stroke:#48b658;}.cls-27{clip-path:url(#clippath-2);}.cls-28{clip-path:url(#clippath-13);}.cls-4{stroke:#74baa2;}.cls-5{stroke:#77bba8;}.cls-29{letter-spacing:0em;}.cls-30{clip-path:url(#clippath-15);}.cls-31{clip-path:url(#clippath-6);}.cls-32{fill:#f4d198;}.cls-33{fill:#f9a133;}.cls-6{stroke:#57b669;}.cls-34{clip-path:url(#clippath-7);}.cls-7{stroke:#a9987d;stroke-width:.37px;}.cls-8{stroke:#6fb996;}.cls-35{letter-spacing:0em;}.cls-36{clip-path:url(#clippath-1);}.cls-37{clip-path:url(#clippath-4);}.cls-38{letter-spacing:0em;}.cls-39{letter-spacing:0em;}.cls-40{fill:#90d0b9;}.cls-9{stroke:#53b563;}.cls-41{clip-path:url(#clippath-12);}.cls-10{stroke:#62b77e;}.cls-42{fill:#c9e6cd;}.cls-43{letter-spacing:-.01em;}.cls-44{clip-path:url(#clippath-9);}.cls-45{letter-spacing:-.02em;}.cls-46{clip-path:url(#clippath);}.cls-47{font-family:CFArmadilloStd-Medium, 'CF Armadillo Std';font-size:11px;font-weight:500;}.cls-47,.cls-48{fill:#2b374c;}.cls-11{stroke:#72ba9c;}.cls-49{clip-path:url(#clippath-19);}.cls-50{fill:#f26c36;}.cls-51{clip-path:url(#clippath-3);}.cls-52{clip-path:url(#clippath-8);}.cls-53{letter-spacing:.01em;}.cls-54{letter-spacing:-.07em;}.cls-55{letter-spacing:-.02em;}.cls-48{font-family:CFArmadilloStd-Light, 'CF Armadillo Std';font-weight:300;}.cls-48,.cls-56{font-size:9px;}.cls-13{stroke:#65b884;}.cls-14{stroke:#5bb670;}.cls-57{clip-path:url(#clippath-18);}.cls-58{letter-spacing:-.06em;}.cls-59{clip-path:url(#clippath-14);}.cls-60{clip-path:url(#clippath-17);}.cls-61{clip-path:url(#clippath-5);}.cls-15{stroke:#68b88a;}.cls-16{stroke:#5eb777;}.cls-56{fill:#373535;font-family:Helvetica-Bold, Helvetica;font-weight:700;}.cls-62{letter-spacing:0em;}.cls-17{stroke:#6cb990;}.cls-63{clip-path:url(#clippath-10);}.cls-18{stroke:#4eb55d;}.cls-64{letter-spacing:-.04em;}.cls-65{letter-spacing:0em;}.cls-19,.cls-20{stroke:#90d0b9;stroke-width:2px;}.cls-20{stroke-linecap:round;stroke-linejoin:round;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    width: 240.95,
    height: 155.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -2.99,
    y: -3.59,
    width: 247.7,
    height: 160.93
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -2.99,
    y: -3.59,
    width: 247.7,
    height: 160.93
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 11.05,
    y: 12.26,
    width: 97.6,
    height: 22.96
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: -2.99,
    y: -3.59,
    width: 247.7,
    height: 160.93
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 67.84,
    y: 36.95,
    width: 125.55,
    height: 83.34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 67.84,
    y: 43.74,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 70.65,
    y: 43.25,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 73.47,
    y: 42.77,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 76.29,
    y: 42.28,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 79.11,
    y: 41.8,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 81.92,
    y: 41.31,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 84.74,
    y: 40.83,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 87.56,
    y: 40.34,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 90.38,
    y: 39.86,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 93.19,
    y: 39.37,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 96.01,
    y: 38.89,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 98.83,
    y: 38.4,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 101.65,
    y: 37.92,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 104.46,
    y: 37.43,
    width: 86.11,
    height: 76.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 107.28,
    y: 36.95,
    width: 86.11,
    height: 76.55
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artwork_3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-46"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "m224.45,155.91H16.5c-9.11,0-16.5-7.39-16.5-16.5V16.5C0,7.39,7.39,0,16.5,0h207.95C233.56,0,240.95,7.39,240.95,16.5v122.91c0,9.11-7.39,16.5-16.5,16.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "m205.7,136.53c-2.43,1.96-5.53,3.13-8.91,3.13-7.85,0-14.22-6.36-14.22-14.22s6.37-14.22,14.22-14.22c3.38,0,6.48,1.17,8.91,3.14-3.25,2.6-5.33,6.6-5.33,11.08s2.08,8.49,5.33,11.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "m211.02,125.44c0,4.48-2.07,8.48-5.32,11.09-3.25-2.6-5.33-6.6-5.33-11.09s2.08-8.48,5.33-11.08c3.25,2.6,5.32,6.6,5.32,11.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "m228.82,125.44c0,7.86-6.37,14.22-14.23,14.22-3.36,0-6.46-1.17-8.89-3.13,3.25-2.61,5.32-6.61,5.32-11.09s-2.07-8.48-5.32-11.08c2.43-1.97,5.53-3.14,8.89-3.14,7.86,0,14.23,6.37,14.23,14.22"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-56",
    transform: "translate(181.43 148.97)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "mastercard")), /*#__PURE__*/React.createElement("text", {
    className: "cls-47",
    transform: "translate(45.05 131.61)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 0,
    y: 0
  }, "45"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-38",
    x: 13.38,
    y: 0
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 19.73,
    y: 0
  }, "9 4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-55",
    x: 36.24,
    y: 0
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-58",
    x: 42.66,
    y: 0
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 48.64,
    y: 0
  }, "4 22"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-45",
    x: 72.06,
    y: 0
  }, "8"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-35",
    x: 78.48,
    y: 0
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 85.22,
    y: 0
  }), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 88.41,
    y: 0
  }, "63"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-64",
    x: 101.51,
    y: 0
  }, "4"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 107.7,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("text", {
    className: "cls-48",
    transform: "translate(45.05 146.51)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 0,
    y: 0
  }, "MAR"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-65",
    x: 18.09,
    y: 0
  }, "IO"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 27.7,
    y: 0
  }, "S "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-54",
    x: 36.07,
    y: 0
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 40.85,
    y: 0
  }, "."), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 42.55,
    y: 0,
    xmlSpace: "preserve"
  }, " I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-43",
    x: 49.03,
    y: 0
  }, "O"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-53",
    x: 54.79,
    y: 0
  }, "ANNI"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-39",
    x: 75.85,
    y: 0
  }, "D"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-62",
    x: 81.78,
    y: 0
  }, "H"), /*#__PURE__*/React.createElement("tspan", {
    x: 87.72,
    y: 0
  }, "S")), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m81.11,15.71c0-.85.26-1.58.77-2.19.68-.81,1.72-1.23,2.78-1.23h20.57c.94,0,1.74.33,2.41.98.67.65,1,1.47,1,2.43v16.08c0,.97-.33,1.78-1,2.43-.67.65-1.47.98-2.41.98h-20.57c-1.06,0-2.09-.42-2.78-1.23-.52-.61-.77-1.34-.77-2.18V15.71Zm24.27,16.37V15.43s-.04-.09-.09-.09h-20.09c-.45,0-.82.37-.82.82v15.19c0,.45.37.82.82.82h20.09s.09-.04.09-.09"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m24.85,35.21h-10.38c-.94,0-1.74-.33-2.41-.98-.67-.66-1.01-1.47-1.01-2.44V15.68c0-.97.34-1.78,1.01-2.44.67-.66,1.48-.98,2.41-.98h10.38v3.04h-10.52v16.86h10.52v3.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m41.78,13.24c-.67-.66-1.48-.98-2.41-.98h-10.37v3.05h10.52v5.85h-15.27c-.94,0-1.74.33-2.41.99-.67.65-1.01,1.47-1.01,2.43v7.21c0,.97.34,1.78,1.01,2.44.68.66,1.48.98,2.41.98h15.13c.94,0,1.74-.33,2.41-.98.67-.66,1.01-1.47,1.01-2.44V15.68c0-.97-.33-1.78-1.01-2.44m-2.27,18.92h-15.41v-7.96h15.41v7.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m78.59,35.21h-3.12v-14.93c-1.79,0-3.58,0-5.38-.01v-4.96h-21.49v8.9h21.5v-1.04h3.28c.03.65-.02,1.14-.07,1.39-.07.33-.18.59-.18.59-.05.13-.26.62-.74,1.1-.07.07-.15.14-.22.2-.62.54-1.35.81-2.22.81h-21.35v7.96h-3.28V15.68c0-.96.33-1.78,1-2.44s1.48-.98,2.42-.98h21.21c.94,0,1.74.33,2.42.98.67.66,1,1.47,1,2.44v1.32h5.18c.01,5.9.02,12.31.03,18.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "m76.92,12.26h0c.9,0,1.64.73,1.64,1.64v.52c0,.9-.73,1.64-1.64,1.64s-1.64-.73-1.64-1.64v-.52c0-.9.73-1.64,1.64-1.64"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m207.55,27.57c-2.12,0-3.84-1.72-3.84-3.84s1.72-3.84,3.84-3.84,3.84,1.72,3.84,3.84-1.72,3.84-3.84,3.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m215.3,32.25c4.7-4.59,4.69-12.2,0-17.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "m221.02,38.21c7.98-7.79,7.98-20.74-.03-28.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "m37.24,79.26v12.29c0,2.4-1.72,4.4-3.99,4.84-.3.06-.62.09-.94.09H15.98c-.32,0-.63-.03-.94-.09-2.27-.44-3.99-2.44-3.99-4.84v-12.29c0-.42.05-.84.16-1.23h0c.55-2.13,2.48-3.7,4.77-3.7h16.34c2.28,0,4.19,1.54,4.76,3.64.11.41.17.84.17,1.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m37.24,79.26v12.29c0,2.4-1.72,4.4-3.99,4.84-.3.06-.62.09-.94.09H15.98c-.32,0-.63-.03-.94-.09-2.27-.44-3.99-2.44-3.99-4.84v-12.29c0-.42.05-.84.16-1.23h0c.55-2.13,2.48-3.7,4.77-3.7h16.34c2.28,0,4.19,1.54,4.76,3.64.11.41.17.84.17,1.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m19.26,77.95c1.43,0,2.59,1.16,2.59,2.59,0,.71-.29,1.36-.76,1.83-.47.47-1.11.76-1.83.76h-7.45c-.25,0-.51,0-.76,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m29.3,77.95c-.72,0-1.36.29-1.83.76-.47.47-.76,1.11-.76,1.83,0,1.43,1.16,2.59,2.59,2.59,2.65,0,5.3.01,7.95.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m11.05,88.82c.41-.2.88-.31,1.37-.31h6.25c1.76,0,3.19,1.43,3.19,3.19v1.49c0,1.76-1.43,3.19-3.19,3.19"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m37.24,88.71c-.34-.12-.71-.19-1.1-.19h-6.25c-1.76,0-3.19,1.43-3.19,3.19v1.49c0,1.76,1.43,3.19,3.19,3.19"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 30.49,
    y1: 83.16,
    x2: 30.49,
    y2: 88.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-7",
    x1: 17.87,
    y1: 83.16,
    x2: 17.87,
    y2: 88.55
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 81.39,
    y: 45.72,
    width: 59,
    height: 72.59,
    transform: "translate(2.73 167.59) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 84.21,
    y: 45.23,
    width: 59,
    height: 72.59,
    transform: "translate(5.27 169.95) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 87.03,
    y: 44.75,
    width: 59,
    height: 72.59,
    transform: "translate(7.82 172.31) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 89.84,
    y: 44.26,
    width: 59,
    height: 72.59,
    transform: "translate(10.37 174.67) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 92.66,
    y: 43.78,
    width: 59,
    height: 72.59,
    transform: "translate(12.92 177.04) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 95.48,
    y: 43.29,
    width: 59,
    height: 72.59,
    transform: "translate(15.47 179.4) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 98.3,
    y: 42.81,
    width: 59,
    height: 72.59,
    transform: "translate(18.02 181.76) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 101.11,
    y: 42.32,
    width: 59,
    height: 72.59,
    transform: "translate(20.56 184.12) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 103.93,
    y: 41.84,
    width: 59,
    height: 72.59,
    transform: "translate(23.11 186.48) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 106.75,
    y: 41.35,
    width: 59,
    height: 72.59,
    transform: "translate(25.66 188.84) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 109.56,
    y: 40.87,
    width: 59,
    height: 72.59,
    transform: "translate(28.21 191.2) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 112.38,
    y: 40.39,
    width: 59,
    height: 72.59,
    transform: "translate(30.76 193.56) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 115.2,
    y: 39.9,
    width: 59,
    height: 72.59,
    transform: "translate(33.31 195.93) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 118.02,
    y: 39.42,
    width: 59,
    height: 72.59,
    transform: "translate(35.86 198.29) rotate(-74.84)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 120.83,
    y: 38.93,
    width: 59,
    height: 72.59,
    transform: "translate(38.4 200.65) rotate(-74.84)"
  })))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankCard2Front);
export default __webpack_public_path__ + "static/media/bank-card-2-front.4554ee7152872a880647d52fb1ccd247.svg";
export { ForwardRef as ReactComponent };